
import React, { useState, useEffect } from "react";
import './opening-hours.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
    Table
  } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import {half_hour_list} from '../../lists/half-hour-list';
import _ from 'lodash';
import ReactGA from 'react-ga';

export default function OpeningHours(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const clinicData = props.location.state.clinicData;

    // const [openHours, setOpenHours] = useState(props.location.state.clinicData);
    const token = localStorage.getItem('token');
    const axiosConfig = {
        headers: {
            Authorization: token
        }
    }

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(true);
    const {register, handleSubmit, reset} = useForm({
        // defaultValues: {
        //     sunday_open: true,      sunday_from:    "10:00",    sunday_to:      '19:00',
        //     monday_open: true,      monday_from:    "10:00",    monday_to:      '19:00',
        //     tuesday_open: true,     tuesday_from:   "10:00",    tuesday_to:     '19:00',
        //     wednesday_open: true,   wednesday_from: "10:00",    wednesday_to:   '19:00',
        //     thursday_open: true,    thursday_from:  "10:00",    thursday_to:    '19:00',
        //     friday_open: false,     friday_from:    "10:00",    friday_to:      '19:00',
        //     saturday_open: false,   saturday_from:  "10:00",    saturday_to:    '19:00',
        // }
    });

    useEffect(() => {
        axios.post('https://uae-dentist-backend.herokuapp.com/account/get-open-hours', {_id: props.location.state.clinicData.opening_hours}, axiosConfig)
        .then ((result) => {
            const openHours = result.data;
            setLoading(false);
            reset({
                    sunday_open: openHours.sunday.open,       sunday_from: openHours.sunday.from,       sunday_to: openHours.sunday.to,
                    monday_open: openHours.monday.open,       monday_from: openHours.monday.from,       monday_to: openHours.monday.to,
                    tuesday_open: openHours.tuesday.open,     tuesday_from: openHours.tuesday.from,     tuesday_to: openHours.tuesday.to,
                    wednesday_open: openHours.wednesday.open, wednesday_from: openHours.wednesday.from, wednesday_to: openHours.wednesday.to,
                    thursday_open: openHours.thursday.open,   thursday_from: openHours.thursday.from,   thursday_to: openHours.thursday.to,
                    friday_open: openHours.friday.open,       friday_from: openHours.friday.from,       friday_to: openHours.friday.to,
                    saturday_open: openHours.saturday.open,   saturday_from: openHours.saturday.from,   saturday_to: openHours.saturday.to,
                })
            // setOpenHours(openHours);
        })
        // eslint-disable-next-line
      }, []);

      const parseOpeningHours = (object) => {
        let parsedData = { 
            sunday:     {open : object.sunday_open,         from : object.sunday_from,       to: object.sunday_to,},
            monday:     {open : object.monday_open,         from : object.monday_from,       to: object.monday_to,},
            tuesday:    {open : object.tuesday_open,        from : object.tuesday_from,      to: object.tuesday_to,},
            wednesday:  {open : object.wednesday_open,      from : object.wednesday_from,    to: object.wednesday_to,},
            thursday:   {open : object.thursday_open,       from : object.thursday_from,     to: object.thursday_to,},
            friday:     {open : object.friday_open,         from : object.friday_from,       to: object.friday_to,},
            saturday:   {open : object.saturday_open,       from : object.saturday_from,     to: object.saturday_to,},
        };
        return parsedData;
    };

 
    
    const onSubmit = async (data) => {
        console.log(data)
        setLoading(true);
        for (var propName in data) { 
            if (data[propName] === null || data[propName] === undefined || data[propName] === '' || data[propName] === '- Please Select -') {
              delete data[propName];
            }
        }
        let postData = {};
        postData.opening_hours = parseOpeningHours(data);
        postData._id = clinicData.opening_hours._id;
        console.log(postData);
        await axios.post('https://uae-dentist-backend.herokuapp.com/account/set-open-hours', postData, axiosConfig)
        .then(function (response) {
            console.log(response.data);
            _.extend(props.location.state.clinicData.opening_hours, postData.opening_hours);
            setLoading(false);
            setSuccess(true);
            setShow(true);
        })
        .catch(function (error) {
            setSuccess(false);
            setShow(true);
            setLoading(false);
            console.log(error);
        })
    };



      return (
            <Container className="mt-5 rounded">
            { show && <GenericModal setShow={setShow} show={show} success={success}/>}
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className = "my-5" lg={12}><Col lg={8}>
                <h1>Pick the days and times that your clinic is open.</h1>
            </Col></Row>
            <div className='mt-5'>
                <SyncLoader
                    size={15}
                    margin={2}
                    color={"#123abc"}
                    loading={loading}
                />
            </div>
            <Table striped>
                <thead>
                <tr>
                    <th><h5>Open</h5></th>
                    <th><h5>Day</h5></th>
                    <th><h5>From</h5></th>
                    <th><h5>To</h5></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                <td><input
                            ref={register}
                            name="sunday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Sunday</h5></td>
                    <td>
                        <Form.Group>
                            <Form.Control as="select"  name="sunday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </td> 
                       
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="sunday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                    <td><input
                            ref={register}
                            name="monday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Monday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="monday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="monday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                <td><input
                            ref={register}
                            name="tuesday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Tuesday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="tuesday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="tuesday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                <td><input
                            ref={register}
                            name="wednesday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Wednesday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="wednesday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="wednesday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                <td><input
                            ref={register}
                            name="thursday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Thursday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="thursday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="thursday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                <td><input
                            ref={register}
                            name="friday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Friday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="friday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="friday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>
                <tr>
                <td><input
                            ref={register}
                            name="saturday_open"
                            type="checkbox"
                        /></td>
                    <td><h5>Saturday</h5></td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="saturday_from"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                    <td>
                    <Form.Group>
                            <Form.Control as="select"  name="saturday_to"  placeholder={'Loading...'}ref={register ({required:true})} custom>
                                {half_hour_list().map((half_hour, idx) => (
                                    <option>{half_hour}</option>
                                ))}
                            </Form.Control>
                    </Form.Group>
                    </td>
                </tr>

                </tbody>
            </Table>
            <Button variant="primary" type="submit">
                    Update Open Hours
            </Button>
                
    </Form>
    </Container>
      );

}

